import {createFilledFromStrokeSVG, createStrokeSVG} from './TEMPLATE'

// tabler: address-book — filled variant generated from the outline (auto-B)
export const Contacts_Filled_Corner2_Rounded = createFilledFromStrokeSVG({
  path: 'M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2 M10 16h6 M11 11a2 2 0 1 0 4 0a2 2 0 1 0 -4 0 M4 8h3 M4 12h3 M4 16h3',
  viewBox: '0 0 24 24',
  strokeWidth: 3,
})

// tabler: address-book
export const Contacts_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2',
    'M10 16h6',
    'M11 11a2 2 0 1 0 4 0a2 2 0 1 0 -4 0',
    'M4 8h3',
    'M4 12h3',
    'M4 16h3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
